import { useToast } from "@repo/ui";

const INDESIGN_TAGS = [
  "<indesign:allxmp>",
  "<indesign:spreadno>",
  "<indesign:pageno>",
  "<indesign:formattedpageno>",
  "<indesign:pageseqno>",
  "<indesign:firstpageno>",
  "<indesign:lastpageno>",
  "<indesign:pagecount>",
  "<indesign:assignmentname>",
  "<indesign:documentname>",
];

// const SMARTXMP_TAGS = [
//   "<kbsmartxmp:package>",
//   "<kbsmartxmp:version>",
//   "<kbsmartxmp:enabled>",
//   "<kbsmartxmp:Aar>",
//   "<kbsmartxmp:Uge>",
//   "<kbsmartxmp:Kunde>",
//   "<kbsmartxmp:Type>",
//   "<kbsmartxmp:Different>",
//   "<kbsmartxmp:Korr>",
// ];

// const STAMPIT_TAGS = [
//   "<kbstampit:filename>",
//   "<kbstampit:shortfilename>",
//   "<kbstampit:filepath>",
//   "<kbstampit:directory>",
//   "<kbstampit:revision>",
// ];

type Props = {
  fieldNames?: string[];
};

export const ActionTagsPanel = ({ fieldNames = [] }: Props) => {
  const { showToast } = useToast();

  const workflowTags = fieldNames.map((name) => `<workflow:${name}>`);

  const categories = [
    { label: "InDesign", tags: INDESIGN_TAGS },
    { label: "Workflow", tags: workflowTags },
    // { label: "Stampit", tags: STAMPIT_TAGS },
    // { label: "Smart XMP", tags: SMARTXMP_TAGS },
  ];

  const handleTagClick = async (tag: string) => {
    try {
      await navigator.clipboard.writeText(tag);
      showToast("success", `Copied "${tag}" to clipboard`, "Copied");
    } catch {
      showToast("error", "Failed to copy to clipboard", "Error");
    }
  };

  return (
    <div className="flex max-h-full w-full flex-col rounded-sm bg-gray-100">
      <div className="mx-4 flex shrink-0 items-center justify-between border-b border-gray-300 px-1 pt-7 pb-3">
        <span className="text-md font-bold">Available tags</span>
        <span className="text-xs text-gray-500">Click tag to copy</span>
      </div>
      <div className="custom-scrollbar mb-3 flex flex-1 flex-col gap-3 overflow-y-auto px-4 py-3">
        {categories.map(({ label, tags }) => (
          <div key={label} className="flex flex-col gap-1">
            <span className="text-xs font-semibold text-gray-600">{label}:</span>
            {tags.length === 0 ? (
              <span className="text-xs text-gray-400 italic">No fields available</span>
            ) : (
              tags.map((tag) => (
                <button
                  key={tag}
                  type="button"
                  title="Click to copy"
                  onClick={() => handleTagClick(tag)}
                  className="cursor-pointer rounded px-1 py-0.5 text-left text-xs text-blue-600 transition-colors hover:bg-blue-50 hover:underline"
                >
                  {tag}
                </button>
              ))
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
